import React from 'react';
import './StatusLegend.scss'

const StatusLegend = () => {

    const statuses = [
        {
            "id": "Not applicable",
            "color": "#ACE874"
        },
        {
            "id": "Complete",
            "color": "#40AF32"
        },
        {
            "id": "Past Due",
            "color": "#D20005"
        },
        {
            "id": "In Progress",
            "color": "#EEBB08"
        },
        {
            "id": "Not Due",
            "color": "#CDCCCC"
        }
    ]
    
    return (
        <div className="status-legend">
            {
                statuses.map(status => {
                    return (
                        <div key={status.id} className="status-legend-item">
                        <span className="status-label">{status.id}</span>
                        <span className="status-color" style={{backgroundColor: status.color}}></span>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default StatusLegend;
